import React from 'react'
import '../Testimonial/Testimonial.css'

const Testimonial = () => {
  return (
    <>
    <div className='full-tes'>
        <section className="testimonials">
  <div className="quotes">
    <input type="radio" id="option-1" name="panel" className="sr-only peer/panel-1" defaultChecked />
    <article>
      <blockquote>
        <p>
          <span className="clip clip-left" />
          I am extremely satisfied with the mining services provided. The team’s professionalism and dedication ensured that our operations ran smoothly and efficiently. Their timely support and advanced mining technologies have greatly improved our productivity. Highly recommend!
        </p>
      </blockquote>
      <div className="user">
        <div>
          <p>Arvind Sharma</p>
          <p>Mining Operations Manager</p>
        </div>
        <img src="https://i.pravatar.cc/150?img=3" alt="Arvind" />
      </div>
    </article>
    <input type="radio" id="option-2" name="panel" className="sr-only peer/panel-2" />
    <article>
      <blockquote>
        <p>
          <span className="clip clip-left" />
          They’ve helped us modernize our mining processes with cutting-edge equipment. Their services have been crucial in enhancing safety standards and boosting operational efficiency. Our mine is more productive, and I’ve already seen a return on investment. Fantastic service!
        </p>
      </blockquote>
      <div className="user">
        <div>
          <p>Ankita Joshi</p>
          <p>Mining Engineer</p>
        </div>
        <img src="https://i.pravatar.cc/150?img=23" alt="Snehal" />
      </div>
    </article>
    <input type="radio" id="option-3" name="panel" className="sr-only peer/panel-3" />
    <article>
      <blockquote>
        <p>
          <span className="clip clip-left" />
          Excellent mining solutions! The team took the time to understand our needs and delivered a solution that optimized our output. The project was completed on time, and we’re now seeing significantly higher yields. I’m incredibly pleased with the results.
        </p>
      </blockquote>
      <div className="user">
        <div>
          <p>Srejal Singh</p>
          <p>Business Owner</p>
        </div>
        <img src="https://i.pravatar.cc/150?img=48" alt="Ravi" />
      </div>
    </article>
    <input type="radio" id="option-4" name="panel" className="sr-only" />
    <article>
      <blockquote>
        <p>
          <span className="clip clip-left" />
          We’ve been working with them for several years now, and their dedication to safety and innovation has been outstanding. The mining site is running more efficiently, and I appreciate their continued support and willingness to go above and beyond.
        </p>
      </blockquote>
      <div className="user">
        <div>
          <p>Kajal Singh</p>
          <p>Operations Head</p>
        </div>
        <img src="https://i.pravatar.cc/150?img=16" alt="Vikram" />
      </div>
    </article>
    <input type="radio" id="option-5" name="panel" className="sr-only" />
    <article>
      <blockquote>
        <p>
          <span className="clip clip-left" />
          They provided excellent solutions for our mining needs. Their innovative approach helped streamline operations and improve efficiency across the board. We’ve seen great results and have been thoroughly impressed with their customer service.
        </p>
      </blockquote>
      <div className="user">
        <div>
          <p>Ajay Mehta</p>
          <p>Mining Project Leader</p>
        </div>
        <img src="https://i.pravatar.cc/150?img=17" alt="Priya" />
      </div>
    </article>
  </div>
  <div className="dots">
    <label id="toggle-1" htmlFor="option-1" aria-label="toggle panel 1" />
    <label id="toggle-2" htmlFor="option-2" aria-label="toggle panel 2" />
    <label id="toggle-3" htmlFor="option-3" aria-label="toggle panel 3" />
    <label id="toggle-4" htmlFor="option-4" aria-label="toggle panel 4" />
    <label id="toggle-5" htmlFor="option-5" aria-label="toggle panel 5" />
  </div>
</section>
</div>
    </>
  )
}

export default Testimonial
